import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactFormService {

  constructor(public http: HttpClient) { }

  public getCountrys(): Observable<any[]> {
    return this.http
      .get<any[]>(`/api/method/atr_marketing.solicitud.getCountrys`);
  }


  public createSolicitud(solicitud: any=''): Observable<any[]> {
    return this.http
      .post<any[]>(`/api/method/atr_marketing.solicitud.createdSolicitud`, solicitud);
  }

  public getEvento(evento: any=''): Observable<any[]> {
    return this.http
      .post<any[]>(`/api/method/atr_marketing.solicitud.getEvento`, evento);
  }

  public getArchivo(arch: any=''): Observable<any[]> {
    return this.http
      .post<any[]>(`/api/method/atr_marketing.solicitud.downloadFile`, arch);
  }

  public createSolicitudEftes(solicitud: any = ''): Observable<any> {
    // Para landings EFTES publicas: si el navegador tiene una sesion
    // autenticada del ERP en .eft-systems.de, Frappe exige el header
    // X-Frappe-CSRF-Token y devuelve 417 si no llega. Mandamos un valor
    // dummy que falla la comparacion y mejor manda el request como Guest
    // efectivo. En navegadores sin sesion previa (instaladores reales)
    // este header no tiene ningun efecto porque CSRF no se chequea para Guest.
    const headers = new HttpHeaders({
      'X-Frappe-CSRF-Token': 'none',
    });
    return this.http
      .post<any>(`/api/method/atr_marketing.solicitud.createSolicitudEftes`, solicitud, { headers });
  }

  public getEventoEftes(name: string): Observable<any> {
    return this.http
      .post<any>(`/api/method/atr_marketing.solicitud.getEventoEftes`, { name });
  }

  public getSolicitud(solicitud): Observable<any[]> {
    return this.http
      .get<any[]>(`/api/method/atr_marketing.solicitud.getSolicitud?name=`+solicitud);
  }

  public getParcipants(event_id: any): Observable<any[]> {
    let data = {
      "event": event_id
    }

    return this.http
      .post<any[]>(`/api/method/atr_marketing.solicitud.getSurveyParticipants`, data);
  }

  public getWinner(event_id: any): Observable<any[]> {
    let data = {
      "event": event_id,
      "random": 1
    }
    
    return this.http
      .post<any[]>(`/api/method/atr_marketing.solicitud.getSurveyParticipants`, data);
  }

}
